import {
	ADD_TICKET_HISTORY_FAIL,
	ADD_TICKET_HISTORY_START, ADD_TICKET_HISTORY_SUCCESS, CLEAN_SEARCHED_TICKETS,
	GENERATE_TICKET_FAIL,
	GENERATE_TICKET_START,
	GENERATE_TICKET_SUCCESS, GET_ALL_INFO_FAIL, GET_ALL_INFO_START, GET_ALL_INFO_SUCCESS,
	GET_TICKET_HISTORY_FAIL,
	GET_TICKET_HISTORY_START,
	GET_TICKET_HISTORY_SUCCESS,
	SEARCH_TICKET_FAIL,
	SEARCH_TICKET_START,
	SEARCH_TICKET_SUCCESS,
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {
	ADD_ALLEGATO_ULR,
	ADD_ANAGRAFICA_URL, ADD_RELAZIONE_URL,
	ADD_TICKET_HISTORY_URL,
	GENERATE_TICKET_URL, GET_ALL_INFO_URL, GET_ALL_TICKET_URL,
	GET_TICKET_HISTORY_URL,
	SEARCH_TICKET_URL, UPDATE_ALLEGATO_ULR, UPDATE_ANAGRAFICA_URL
} from "./utils/ApiUrls";
import {getConfig} from "./utils/ConfigUtils";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {authLogout} from "./AuthServices";
import {getCompanyInfo} from "../utils/GenericUtils";
import {getAddAllegatoData} from "./utils/ApiData";
import {relations} from "../utils/dictionaries/Generics";

export async function addAnagrafica(anagrafica, callBackFunction) {
	await axios
		.post(ADD_ANAGRAFICA_URL, anagrafica)
		.then(response => callBackFunction(response.data?.idSoggetto))
		.catch(error => {
			let message = getErrorMessage(error);
			if (message.includes("Anagrafica già esistente")) {
				let idSoggetto = parseInt(message.replace(/\D/g, ''));
				axios
					.post(UPDATE_ANAGRAFICA_URL + idSoggetto, {...anagrafica, idSoggetto: idSoggetto}, getConfig())
					.then(() => callBackFunction(idSoggetto))
					.catch((error) => alert(getErrorMessage(error)))
			} else {
				alert(message);
			}
		})
}

export function generateTicket(ticket, dispatch) {
	console.log(ticket);
	dispatch({type: GENERATE_TICKET_START});
	if (ticket.associati.length > 0) {
		let anagraficheId = [];
		ticket.associati.forEach((associato) => {
			
			/**
			 * Faccio una createAnagrafica (POST) per ogni associato e ne salvo l'id dentro l'array @anagraficheId
			 */
			addAnagrafica(associato, (idSoggetto) => {
				anagraficheId.push({id: idSoggetto, tipoRelazione: associato.tipoRelazione});
				if (anagraficheId.length === ticket.associati.length) {
					
					/**
					 * Genero il ticket e mi prendo l'idSoggetto per poter creare le relazioni
					 */
					axios
						.post(GENERATE_TICKET_URL, {
							...ticket,
							pazientiAssociati: anagraficheId.map(item => item.id).join(",")
						}, getConfig() && getConfig())
						.then((response) => {
							
							/**
							 * Ciclo sull'array delle anagfrafiche per creare le relazioni
							 */
							anagraficheId.forEach((item, indexAnagrafica) => {
								axios
									.post(ADD_RELAZIONE_URL + `${response.data?.idSoggetto}/${item.id}/${item.tipoRelazione}`, {
										src: response.data?.idSoggetto,
										dst: item.id,
										type: item.tipoRelazione
									}, getConfig())
									.then(() => {
										axios
											.post(ADD_RELAZIONE_URL + `${item.id}/${response.data?.idSoggetto}/${item.tipoRelazione}`, {
												dst: response.data?.idSoggetto,
												src: item.id,
												type: relations[item.tipoRelazione]
											}, getConfig())
											.then(() => {
												if (indexAnagrafica === (ticket.associati.length - 1)) {
													dispatch({type: GENERATE_TICKET_SUCCESS});
												}
											})
										
									})
							})
							
							dispatch({type: GENERATE_TICKET_SUCCESS})
						})
						.catch((error) => {
							dispatch({type: GENERATE_TICKET_FAIL, error: getErrorMessage(error)})
						})
				}
			}).then(() => {
			})
		})
	} else {
		if (ticket.allegato) {
			let allegati = [];
			ticket.allegato.forEach((allegato) => {
				axios
					.post(ADD_ALLEGATO_ULR + "/-1", getAddAllegatoData(allegato))
					.then((response) => {
						allegati.push(response.data);
						if (ticket.allegato.length === allegati.length) {
							axios
								.post(GENERATE_TICKET_URL, {
									...ticket,
									allegato: allegati.join(" ")
								}, ticket.type === "EXT" ? {} : getConfig())
								.then((ticketResponse) => {
									/**
									 * Faccio la updateAllegato prendendoli dal ticket...
									 */
									console.log(allegati);
									allegati.forEach((file, index) => {
										console.log(file, index)
										console.log(ticketResponse.data.idSoggetto);
										console.log(allegati.length === (index + 1));
										axios
											.post(UPDATE_ALLEGATO_ULR + file + "/" + ticketResponse.data.idSoggetto, ticket.type === "EXT" ? {} : getConfig())
											.then(() => {
												if (allegati.length === (index + 1)) {
													dispatch({type: GENERATE_TICKET_SUCCESS})
												}
											})
									})
									//fine update
								})
								.catch((error) => {
									console.log("error2")
									console.log(JSON.stringify(error))
									dispatch({type: GENERATE_TICKET_FAIL, error: getErrorMessage(error)})
								})
						}
					})
			})
		} else {
			axios
				.post(GENERATE_TICKET_URL, ticket, ticket.type === "EXT" ? {} : getConfig())
				.then(() => dispatch({type: GENERATE_TICKET_SUCCESS}))
				.catch((error) => dispatch({type: GENERATE_TICKET_FAIL, error: getErrorMessage(error)}))
		}
	}
}

export function resetAddTicket(dispatch) {
	dispatch({type: GENERATE_TICKET_START});
}

export function searchTicket(ticket, dispatch) {
	dispatch({type: SEARCH_TICKET_START});
	axios
		.post(SEARCH_TICKET_URL, ticket, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: SEARCH_TICKET_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: SEARCH_TICKET_FAIL, error: getErrorMessage(error)}));
}

export function getTicketHistory(ticket, dispatch, token = "NULL") {
	dispatch({type: GET_TICKET_HISTORY_START});
	axios
		.get(GET_TICKET_HISTORY_URL + ticket.id + "/" + token, token === "NULL" ? getConfig() : {})
		.then((response) => dispatch({type: GET_TICKET_HISTORY_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_TICKET_HISTORY_FAIL, error: getErrorMessage(error)}));
}

export async function getArrayTicketHistory(id, callBackFunction) {
	await axios
		.get(GET_TICKET_HISTORY_URL + id + "/NULL", getConfig())
		.then((response) => {
			console.log(response);
			callBackFunction(response.data);
		})
		.catch((error) => alert(getErrorMessage(error)))
}

export function updateTicket(ticket, dispatch, token = "NULL", isMail = false, codF = "NULL", idSoggetto) {
	dispatch({type: ADD_TICKET_HISTORY_START});
	if (ticket.allegati) {
		let allegati = [];
		ticket.allegati.forEach((allegato) => {
			axios
				.post(ADD_ALLEGATO_ULR + "/" + idSoggetto, getAddAllegatoData(allegato))
				.then((response) => {
					allegati.push(response.data);
					if (ticket.allegati.length === allegati.length) {
						axios
							.post(ADD_TICKET_HISTORY_URL + token + "/" + isMail + "/" + codF, {
								...ticket,
								allegato: allegati.join(" ")
							}, codF === "NULL" ? getConfig() : {})
							.then(() => {
								/**
								 * Faccio la updateAllegato prendendoli dal ticket...
								 */
								allegati.forEach((file, index) => {
									axios
										.post(UPDATE_ALLEGATO_ULR + file + "/" + idSoggetto, {}, token === "NULL" ? getConfig() : {})
										.then(() => {
											if (allegati.length === (index + 1)) {
												dispatch({type: ADD_TICKET_HISTORY_SUCCESS});
												if (token === "NULL") {
													getTicketHistory(ticket, dispatch);
												}
											}
										})
								})
								//fine update
							})
							.catch((error) => dispatch({type: ADD_TICKET_HISTORY_FAIL, error: getErrorMessage(error)}))
					}
				})
				.catch((error) => dispatch({type: ADD_TICKET_HISTORY_FAIL, error: getErrorMessage(error)}))
		})
	} else {
		axios
			.post(ADD_TICKET_HISTORY_URL + token + "/" + isMail + "/" + codF, {
				...ticket,
				allegato: null
			}, codF === "NULL" ? getConfig() : {})
			.then(() => {
				dispatch({type: ADD_TICKET_HISTORY_SUCCESS});
				if (token === "NULL") {
					getTicketHistory(ticket, dispatch);
				}
			})
			.catch((error) => dispatch({type: ADD_TICKET_HISTORY_FAIL, error: getErrorMessage(error)}))
	}
}

export function cleanSearchedTickets(dispatch) {
	dispatch({type: CLEAN_SEARCHED_TICKETS});
}

export function resetAddHistory(dispatch) {
	dispatch({type: ADD_TICKET_HISTORY_START});
}

export function getAllTicket(ticket, dispatch) {
	dispatch({type: SEARCH_TICKET_START});
	axios
		.post(GET_ALL_TICKET_URL, ticket, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: SEARCH_TICKET_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: SEARCH_TICKET_FAIL, error: getErrorMessage(error)}))
}

export function getAllInfo(dispatch, category = null, src = "CIT", level) {
	dispatch({type: GET_ALL_INFO_START})
	axios
		.post(GET_ALL_INFO_URL, {
			src: src, dst: getCompanyInfo().roleDetails?.replace("ROLE_", ""), categoria: category, livello: level
		}, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_ALL_INFO_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_ALL_INFO_FAIL, error: getErrorMessage(error)}))
}
